export default `<svg width="320" height="384" viewBox="0 0 320 384" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M48 0C21.5 0 0 21.5 0 48V336C0 362.5 21.5 384 48 384H80C106.5 384 128 362.5 128 336V48C128 21.5 106.5 0 80 0H48ZM240 0C213.5 0 192 21.5 192 48V336C192 362.5 213.5 384 240 384H272C298.5 384 320 362.5 320 336V48C320 21.5 298.5 0 272 0H240Z" fill="currentColor"/>
</svg>
`